<div [formGroup]="travelTypeForm">
    Code
    <input formControlName="code">
    Type
    <select formControlName="type">
        <option [ngValue]="type" *ngFor="let type of types">{{type.name}}</option>
    </select>
    Description
    <input formControlName="description">
    Notes de facturation
    <input formControlName="billingNote">
    Commentaires généraux
    <input formControlName="comment">
    <button (click)="sendTravelType()">Submit</button>
</div>